<template>
  <div class="card mt-3" header-bg-variant="white">
    <div class="card-body">
      <div class="row mb-2 ">
        <div class="col">
          <h5 data-test-hook="plan-cost-header-text">
            {{ $t('xDealerManaged') }}
          </h5>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <span data-test-hook="plan-cost-header-text">
            {{ $t('xPlanStatus') }}
          </span>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <strong data-test-hook="plan-cost">
            {{ productDealerManaged.apparatusName }}&nbsp;{{ $t('xIsManagedByYourDealer') }}
          </strong>
        </div>
      </div>

      <div class="accordion" role="tablist" style="width:100%;">
        <div class="accordion-wrapper" style="border: 1px solid lightgrey; padding: 10px; border-radius: 10px;">
          <div v-b-toggle="'collapse-dealerManaged-' + productDealerManaged.apparatusId">
            <div class="row align-items-center no-gutters">
              <div class="col align-items-center">
                <i class="fa-regular fa-circle-info pr-2"></i><strong>{{ $t('xProductsAndFeatures') }}</strong>
              </div>
              <div class="col-auto">
                <i class="fas fa-chevron-down when-closed"></i>
                <i class="fas fa-chevron-up when-open"></i>
              </div>
            </div>
          </div>
          <b-collapse :id="'collapse-dealerManaged-' + productDealerManaged.apparatusId">
            <div class="row">
              <div class="col">
                <hr class="mx-0 px-0" />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <p class="mb-0 pb-0">
                  <strong data-test-hook="products-included-text">
                    {{ $t('xProductsCoveredByDM') }}
                  </strong>
                </p>
              </div>
            </div>
            <i :class="getApparatusIcon(productDealerManaged.apparatusType)"></i>&nbsp;&nbsp;{{
              productDealerManaged.apparatusName
            }}
            <div class="row mt-3 mb-2">
              <div class="col">
                <p class="mb-0 pb-0">
                  <strong data-test-hook="products-included-text">
                    {{ $t('xFeaturesIncludedInDM') }}
                  </strong>
                </p>
              </div>
            </div>
            <div v-if="productDealerManaged.apparatusType === hsbApparatusType">
              <div class="row mb-3">
                <div class="col icon-and-text">
                  <i class="fa-kit fa-fw fa-generator"></i>
                  <span data-test-hook="features-included-list">
                    {{ $t('xFeaturesInDMHsb1') }}
                  </span>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col icon-and-text">
                  <i class="fal fa-check-circle"></i>
                  <span data-test-hook="features-included-list">
                    {{ $t('xFeaturePremiumMonitoringForOneHsb') }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="productDealerManaged.apparatusType === fuelTankApparatusType">
              <div class="row mb-3">
                <div class="col icon-and-text">
                  <i class="fa-kit fa-fw fa-generator"></i>
                  <span data-test-hook="features-included-list">
                    {{ $t('xSubFeaturesFmFuelLevelHistoryWarningsBattery') }}
                  </span>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col icon-and-text">
                  <i class="fal fa-check-circle"></i>
                  <span data-test-hook="features-included-list">
                    {{ $t('xSubFeaturesFmMonitorOneFm') }}
                  </span>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>

      <button
        type="button"
        class="btn btn-warning mt-3"
        @click="openDealerInfo(productDealerManaged.apparatusId)"
        data-test-hook="openSubscribePremiumMonitoringBtn"
      >
        {{ $t('xViewDealerInformation') }}
      </button>
    </div>
  </div>
</template>

<script>
import * as Constants from '@/constants'

export default {
  props: ['productDealerManaged'],
  computed: {
    hsbApparatusType() {
      return Constants.HsbApparatusType
    },
    fuelTankApparatusType() {
      return Constants.FuelTankApparatusType
    }
  },
  methods: {
    openDealerInfo(apparatusId) {
      this.$router.push({
        path: `/details/` + apparatusId + `/preferredDealer`
      })
    },
    getApparatusIcon(type) {
      switch (type) {
        case Constants.HsbApparatusType:
          return 'fa-kit fa-fw fa-generator'
        case Constants.FuelTankApparatusType:
          return 'fa-kit fa-fw fa-tank'
        default:
          return 'fa-kit fa-fw fa-generator'
      }
    }
  }
}
</script>
